import type { EffectivePriceSegment } from '@cvo/domain/api';
import { deriveEffectivePrice } from '@cvo/domain';
import { computed, type MaybeRefOrGetter, toValue } from 'vue';

/**
 * Reactive wrapper over `deriveEffectivePrice`: recomputes when the schedule changes and exposes
 * each derived value as a computed ref. All pricing logic lives in the pure util.
 * @param schedule - The subscription's list of upcoming price changes
 */
export function useEffectivePrice(schedule: MaybeRefOrGetter<EffectivePriceSegment[] | null | undefined>) {
  const info = computed(() => deriveEffectivePrice(toValue(schedule)));

  return {
    currentSegment: computed(() => info.value.currentSegment),
    isPromotional: computed(() => info.value.isPromotional),
    isEvergreen: computed(() => info.value.isEvergreen),
    revertsAt: computed(() => info.value.revertsAt),
    fullPrice: computed(() => info.value.fullPrice),
    savings: computed(() => info.value.savings),
  };
}
